///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />


namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    // @ts-ignore
    import IScope = angular.IScope;
    // @ts-ignore
    import PollsRepository = TotalPoll.Repository;

    @Controller('controllers.totalpoll')
    // @ts-ignore
    export class MainController {

        protected page: number = 1;
        protected polls: any = [];
        protected presets = [];

        protected processing: boolean = false;

        public initialized: boolean = false;
        public selectedPolls: any = [];
        public selectedPreset = null;
        public done: any = [];
        public total = 0;

        public constructor(
            private Repository: Repository,
            private $scope: IScope,
            presets
        ) {
            this.presets = presets;
        }

        $onInit() {
            this.Repository.getPolls(this.page).then((polls) => {
                this.initialized = true;
                this.polls.push(...polls);
            });
        }

        loadPolls($event) {
            $event.target.setAttribute('disabled', 'true');

            this.page++;
            this.Repository.getPolls(this.page).then((polls) => {
                this.polls.push(...polls);
                $event.target.removeAttribute('disabled');
            });
        }

        togglePoll(poll: number) {
            if (this.processing) {
                return;
            }

            if (this.selectedPolls.includes(poll)) {
                const index = this.selectedPolls.indexOf(poll);
                this.selectedPolls.splice(index, 1);
            } else {
                this.selectedPolls.push(poll);
            }
        }

        selectPreset(preset) {
            if (!this.processing && !this.isPresetDisabled()) {
                this.selectedPreset = preset;
            }
        }

        isPollSelected(poll: number) {
            return this.selectedPolls.includes(poll);
        }

        isPollsDisabled() {
            return this.processing;
        }

        isPresetDisabled() {
            return this.selectedPolls.length === 0 || this.processing;
        }

        isDisabled() {
            return this.selectedPolls.length === 0 || this.selectedPreset === null || this.processing;
        }

        isReady() {
            return this.polls.length > 0 && this.presets.length > 0;
        }

        getPollObject(id) {
            return this.polls.find(poll => poll.ID === id);
        }

        getProgress() {
            const done = parseInt(this.done.length, 10);
            if(done === 0) {
                return 0;
            }
            return Math.round(( done / this.total) * 100);
        }

        applyPreset() {

            if(! confirm('Are you sure? this is an irreversible action.')) {
                return;
            }

            this.processing = true;
            this.done = [];
            this.total = this.selectedPolls.length;

            const requests = this.selectedPolls.reduce((previous:Promise<any>, id:number) => {
                return previous.then((all) => {
                    let post = this.getPollObject(id);

                    let poll = {
                        id: post.ID,
                        title: post.post_title,
                        success: false
                    };

                    return this.Repository.applyPreset(id, this.selectedPreset.ID).then((response) => {
                        poll.success = response.success;
                        this.done.push(poll);

                        // @ts-ignore
                        return Promise.resolve(all);
                    });
                })
                // @ts-ignore
            }, Promise.resolve([]));

            requests.finally(() => {
                this.selectedPolls = [];
            })
        }

        reset() {
            this.selectedPolls = [];
            this.selectedPreset = null;
            this.processing = false;
            this.done = [];
        }

        resetPolls() {
            this.selectedPolls = [];
        }
    }
}
